import { createNamespacedHelpers } from 'vuex';

import {
    levelAnonymous,
    // levelSemiAuthenticated,
    levelBasicUser,
    levelRegisteredUser,
    levelProUser
} from '@/store/user';

const { mapState } = createNamespacedHelpers('user');

/**
 * Group "Edit" (Webeditori) grants access rights to publish site-wide.
 */
export const hasAccessToGlobalWebEditor = function (groups) {
    return !!_.find(groups, {GroupName: 'Edit'});
};

/**
 * Member of any "*Edit" group.
 */
export const hasAccessToEdit = function (groups) {
    return _.filter(groups, group => group.GroupName && group.GroupName.match('Edit')).length > 0;
};

/**
 * Member of "FinnishartService" or "RegisteredUsers" groups.
 */
export const hasAccessToUseProfile = function (groups) {
    const upGroups = _.filter(groups, (group) => {
        if (group.GroupName && (group.GroupName.match('FinnishartService') || group.GroupName.match('RegisteredUsers'))) {
            return null;
        }
        return group;
    });
    return upGroups.length > 0;
};

export const getUserMembershipLevel = (userProfile) => {

    // check profile Membership level
    let membershipLevel = levelAnonymous;

    // User with Edit Privileges
    if (userProfile && hasAccessToEdit(userProfile.Memberships)) {
        membershipLevel = levelProUser;
    }

    // User with UseProfile Privileges
    else if (userProfile && hasAccessToUseProfile(userProfile.Memberships)) {
        membershipLevel = levelRegisteredUser;
    }

    // User with no Memberships
    else if (userProfile) {
        membershipLevel = levelBasicUser;
    }

    return membershipLevel;
};


export default {

    computed: {
        ...mapState({
            userSession: state => state.session
        }),

        ...mapState({
            userProfile: state => state.profile
        }),

        ...mapState({
            membershipLevel: state => state.membershipLevel
        })
    },

    data: function () {
        return {
            hasUserAccessToEdit: false,         // show pencil icon in navbar?
            hasUserAccessToUseProfile: false,   // show lock-earth icon in navbar?
            isUserWebEditor: false              // can publish everywhere
        };
    },

    created: function () {
        this.hasUserAccessToEdit = this.getUserAccessToEdit();
        this.hasUserAccessToUseProfile = this.getUserAccessToUseProfile();
        this.isUserWebEditor = this.getUserAccessToWebEditor();
    },

    watch: {
        userProfile: function () {
            this.hasUserAccessToEdit = this.getUserAccessToEdit();
            this.hasUserAccessToUseProfile = this.getUserAccessToUseProfile();
            this.isUserWebEditor = this.getUserAccessToWebEditor();
        }
    },

    methods: {
        getUserId: function () {
            return this.$store.getters['user/getUserId'];
        },

        /**
         * Return group User has membership to.
         */
        getUserGroup: function (groupId) {
            const memberships = this.userProfile && this.userProfile.Memberships;
            // const memberships = this.$store.getters['user/getMemberships'];
            return _.find(memberships, {GroupId: groupId});
        },

        /**
         * Return group (by group name) User has membership to.
         */
        getUserGroupByName: function (groupName) {
            const memberships = this.userProfile && this.userProfile.Memberships;
            return _.find(memberships, {GroupName: groupName});
        },

        /**
         * Return group (by group display name) User has membership to.
         */
        getUserGroupByDisplayName: function (groupDisplayName) {
            const memberships = this.userProfile && this.userProfile.Memberships;
            return _.find(memberships, {GroupDisplayName: groupDisplayName});
        },

        isUserInGroups: function (groups) {
            return _.filter(groups, this.getUserGroup).length > 0;
        },

        /**
         * Returns whether user has access to Edit groups.
         */
        getUserAccessToEdit: function () {
            return hasAccessToEdit(this.userProfile && this.userProfile.Memberships);
        },

        /**
         * Returns whether user has access to UseProfile switch (locked-earth icon).
         * Ignore `FinnishartService` and `RegisteredUsers` groups.
         * Other group memberships gain this privilege.
         */
        getUserAccessToUseProfile: function () {
            return hasAccessToUseProfile(this.userProfile && this.userProfile.Memberships);
        },

        getUserAccessToWebEditor: function () {
            return hasAccessToGlobalWebEditor(this.userProfile && this.userProfile.Memberships);
        },

        acceptTermsOfService: function () {
            return this.$SVC.patchProfile({ TermsOfServiceAccepted: true });
        },

        acceptPrivacyPolicy: function () {
            return this.$SVC.patchProfile({ PrivacyPolicyAccepted: true });
        },

        setSharingToRegistered: function (value) {
            return this.$SVC.patchProfile({ SharingToRegistered: value });
        }
    }
};
